/**
 * Tarjeta plegable del modal de un pedido (ADM-09): icono, titulo y cuerpo.
 *
 * `<details>` nativo, como `BloqueInfo` de la ficha: abre y cierra con teclado
 * sin una linea de JavaScript. El titulo es un `<h3>` dentro del `<summary>`
 * (el unico encabezado que admite) para que la jerarquia del modal siga
 * leyendose con la tarjeta cerrada.
 */
import type { ReactNode } from 'react';

import { Icono, type NombreIcono } from '../comunes/Icono';

export interface TarjetaPedidoProps {
  icono: NombreIcono;
  titulo: string;
  /** Dato corto junto al titulo: "(3 unidades)", "(Webpay)". */
  detalle?: string;
  abierta?: boolean;
  /** Ocupa las dos columnas de la grilla. */
  ancha?: boolean;
  children: ReactNode;
}

export function TarjetaPedido({
  icono,
  titulo,
  detalle,
  abierta = false,
  ancha = false,
  children,
}: TarjetaPedidoProps) {
  return (
    <details className={ancha ? 'tarjeta-pedido ancha' : 'tarjeta-pedido'} open={abierta}>
      <summary className="tarjeta-pedido-cab">
        <span className="tarjeta-pedido-icono">
          <Icono nombre={icono} />
        </span>
        <h3>
          {titulo}
          {detalle !== undefined ? <span className="cuenta"> {detalle}</span> : null}
        </h3>
      </summary>
      <div className="tarjeta-pedido-cuerpo">{children}</div>
    </details>
  );
}
